import { getPublicUser } from "../../services/api/Api";
import { setBoardsIconLinks } from "../../util/Scripts";
import {
   setUserInfo,
   userSignInSuccess,
   setMainPageURL,
   setUserBoards,
} from "../../appRedux/actions/Actions";
import { mobileStartActionByUrl } from "@util/Scripts";
import { mobileStartFlutterActionByUrl } from "../../util/Scripts";
import projectConfig from "@projectConfig";
import { store, history } from "../../appRedux/store/Store";

export function authorizePublicUserEntry(publicUser, publicBoards) {
   store.dispatch(setUserInfo(publicUser));
   store.dispatch(setUserBoards(publicBoards));
   store.dispatch(userSignInSuccess(publicUser.id));

   localStorage.setItem("publicID", publicUser.id);
   localStorage.setItem("isPublicUserLogged", true);
}
